/** @format */

//importing components
import DynamicTable from "../../components/global/DynamicTable";
//import components
import HeadTitle from "../../components/global/HeadTitle";

import Grid from "../../components/costs/grid";

//import table data
import { tableColumnCosts } from "../../components/table/col-data";
import AddExpense from "../../components/pops/expense/AddExpense";
import { useDispatch, useSelector } from "react-redux";
import { addExpense } from "../../store/stateSlice";
import ShowDetailsExpense from "../../components/pops/expense/ShowDetailsExpense";
import Table from "../../components/Table2";
import { tableCosts } from "../../constant/table";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";
import { useEffect } from "react";
import { getAllClients } from "../../services/clintServices";
import { Spinner1 } from "../../components/spinners/Spinner1";
import { getAll } from "../../store/helper";
import { useState } from "react";
import { getAllExpenses, getStatisticExpenses } from "../../store/expenses";

const Costs = () => {
  const dispatch = useDispatch();
  const expensesData = useSelector((state) => state.expenses);
  const statisticData = useSelector((state) => state.expenses.statistic);
  const render = useSelector((state) => state.toggleState.value.render);
  const [isOpen, setOpen] = useState(false);
  const [isOpenDetails, setOpenDetails] = useState(false);

  useEffect(() => {
    dispatch(getAllExpenses("/driversMonies"));
    dispatch(getStatisticExpenses("/driversMonies-statistics"))
  }, [dispatch, render]);


  return (
    <NavbarAndSidebar>
      <AddExpense isOpen={isOpen} setOpen={setOpen} toggleModal={() => setOpen(false)} />
      <ShowDetailsExpense isOpenDetails={isOpenDetails} setOpenDetails={setOpenDetails} toggleModal={() => setOpenDetails(false)}  from='cost' />
      <div className='flex-between'>
        <HeadTitle title='المصروفات' margin={true} />
        <button
          className='btn btn__primary'
          onClick={() => setOpen(true)}>
          {" "}
          اضافه مصروف{" "}
        </button>
      </div>
      <Grid statisticData={statisticData}/>
      <div className='mb__small' />
      <Table
        data={expensesData?.allServiceInExpensess}
        header={tableCosts}
        details1="driver"
        details2="name"
        setOpenEdit={setOpenDetails}
        name='expenses'
      />
      {/* <DynamicTable tableColumn={tableColumnCosts} /> */}
      {expensesData.loading && <Spinner1 />}

    </NavbarAndSidebar>
  );
};
export default Costs;
